import React from "react";
import footerLayer from "../../assets/images/footer/svg/footer-layer.svg";
import logoImg from "../../assets/images/svg/logo.svg";

import { Link } from "react-router-dom";
import new_logo from "../../assets/images/webp/NEW_LOGO.webp";
import { FaceBookIcon, TwitterIcon, YouTubeIcon } from "./icons/Icons";
import { socialLinksList } from "../../utils/NavbarHelper";
const Footer = () => {
  const getYear = new Date().getFullYear();
  return (
    <>
      <footer
        className="footer_bg_parent bg_orange d-flex justify-content-end flex-column position-relative"
        id="contact-us"
      >
        <div className="position-absolute footer_layer w-100">
          <img src={footerLayer} alt="footer-layer" className="w-100" />
        </div>
        <div className="container container_modified">
          <div className="row">
            <div className="col-lg-6">
              {/* <a href="/" className="footer-logo">
                <img 
                  src={new_logo} 
                  alt="logo" 
                  style={{
                    maxWidth: '100%',
                    height: 'auto',
                    maxHeight: '70px',
                    objectFit: 'contain'
                  }}
                />
              </a> */}
              <h5 className="font-sm fw-bold text-white mb-0">Contact Us</h5>
              <p className="font-sm fw-medium text-white pt-4 mb-0 lh_25">
                Shree Girnar Sadhana Ashram, <br />
                Bhavnath Taleti, Girnar, Junagadh (362004) <br />
                <a href="tel:9909942280" className="text-white text-decoration-none footer_links transition_03">Phone: 9909942280</a> <br />
                <a href="mailto:contact@sahajyoga.org" className="text-white text-decoration-none footer_links transition_03">Email: contact@sahajyoga.org</a> <br />
                <a href="mailto:admin@dattadham.net" className="text-white text-decoration-none footer_links transition_03">admin@dattadham.net</a>
              </p>
            </div>
            <div className="col-4 col-lg-2 pt-4 pt-lg-0 mt-2 mt-lg-0">
              <h5 className="font-sm fw-bold text-white mb-0">Links</h5>
              <div className="d-grid gap-2 gap-sm-3 mt-2 pt-1 pt-sm-0 mt-sm-4">
                <a
                  href="/#about-us"
                  className="font-sm fw-medium text-white text-decoration-none footer_links transition_03"
                >
                  About Us
                </a>
                <a
                  href="/#great-souls"
                  className="font-sm fw-medium text-white text-decoration-none footer_links transition_03"
                >
                  Great Souls
                </a>
                <a
                  href="/#mahamantra"
                  className="font-sm fw-medium text-white text-decoration-none footer_links transition_03"
                >
                  Mahamantra
                </a>
              </div>
            </div>
            <div className="col-4 col-lg-2 pt-4 pt-lg-0 mt-2 mt-lg-0">
              <h5 className="font-sm fw-bold text-white mb-0">Legal</h5>
              <div className="d-grid gap-2 gap-sm-3 mt-2 pt-1 pt-sm-0 mt-sm-4">
                <a
                  href="#privacy-policy"
                  className="font-sm fw-medium text-white text-decoration-none footer_links transition_03 text-nowrap"
                >
                  Privacy Policy
                </a>
                <a
                  href="#terms-of-use"
                  className="font-sm fw-medium text-white text-decoration-none footer_links transition_03 text-nowrap"
                >
                  Terms of Use
                </a>
              </div>
            </div>
            <div className="col-4 col-lg-2 pt-4 pt-lg-0 mt-2 mt-lg-0">
              <h5 className="font-sm fw-bold text-white mb-0">Follow Us</h5>
              <div className="mt-2 pt-1 pt-sm-0 mt-sm-4 d-flex gap-2">
                {socialLinksList.map((obj, index) => {
                  return (
                    <Link
                      key={index}
                      className="text-decoration-none social_icons"
                      target="_blank"
                      to={obj.to}
                    >
                      {obj.title("white","#E97219")}
                    </Link>
                  );
                })}
              </div>
            </div>
          </div>
          <div className="pt-4">
            <hr className="text-white mb-0 opacity_32" />
            <p className="font-sm fw-medium text-white text-center mb-0 py-2 py-sm-4">
              © {getYear} Copyrights. All Rights Reserved
            </p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
